import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Grid } from '@material-ui/core';

import WizardLayout from '../../components/WizardLayout';
import PlanCardDetail from '../../components/PlanCardDetail';
import CollapsableDetails from '../../components/CollapsableDetails';
import AssistanceServices from '../../components/AssistanceServices';
import WizardNavigation from '../../components/WizardNavigation';

import useWizardSteps from '../../hooks/useWizardSteps';
import Modal from '../../components/Modal';
import ModelForm from '../../components/ModelForm';
import { getPlanInfo } from '../../utils';
import LifeDeclaration from '../../components/LifeDeclaration';
import CompanyInfo from '../../components/CompanyInfo';

const nextSteps = {
  HOGAR: '/domicilio',
  'PERTENENCIAS PROTEGIDAS': '/beneficiarios',
  'MOVILIDAD': '/beneficiarios',
  'ACCIDENTES PERSONALES': '/beneficiarios',
  'ROBO EN CAJERO AUTOMATICO': '/beneficiarios',
  MASCOTA: '/mascota/detalles',
  AUTOMOTOR: '/automotor/datosauto',
};

export default function PlanInfo() {
  const [isOpen, setOpen] = useState(false);

  const { plan, insurance, insurancePlans } = useSelector(
    ({ insurances, insurancePlans }) => ({
      insurance: insurances.selected,
      plan: insurancePlans.selected,
      insurancePlans: insurancePlans.plans,
    })
  );

  const plansInfo = require('./../../data/plans-info.json');

  // remove when service is implemented
  const data = plansInfo[insurance.insuranceName];

  // assitance details still don't come from the endpoint
  const { insuranceName } = insurance;
  const mockedData = getPlanInfo(insuranceName);
  const nextStep = nextSteps[insuranceName];
  const [activeStep] = useWizardSteps(
    insuranceName === 'INTEGRAL DE COMERCIO' || insuranceName === 'AUTOMOTOR'
      ? 2
      : 1
  );

  const renderModal = () => {
    if (insurance.insuranceName === 'TECNO') {
      return <ModelForm closeModal={closeModal} />;
    } else if (insurance.insuranceName === 'INTEGRAL DE COMERCIO') {
      return <CompanyInfo closeModal={closeModal} />;
    } else {
      return <LifeDeclaration closeModal={closeModal} />;
    }
  };

  const closeModal = (isOpen) => {
    setOpen(isOpen);
  };

  return (
    <>
      {isOpen && <Modal>{renderModal()}</Modal>}
      <WizardLayout
        activeStep={activeStep}
        withoutSuggestion
        showNextButton={false}
      >
        <Grid item xs={11} sm={12} container justify='center'>
          <Grid item xs={10} container justify='center'>
            <PlanCardDetail
              plan={plan}
              nextStep={nextStep}
              handleModal={closeModal}
            />
          </Grid>
          <Grid item xs={12}>
            <AssistanceServices
              sectionTitle='*Servicio de asistencias'
              section={insuranceName.toLowerCase()}
              data={mockedData.coverages}
            />
          </Grid>
          <Grid item xs={12}>
            <CollapsableDetails data={data} />
          </Grid>
          <Grid item xs={12}>
            <WizardNavigation next={false} />
          </Grid>
        </Grid>
      </WizardLayout>
    </>
  );
}
